import React from 'react';
import { LandingPageTemplate } from './LandingPageTemplate';

export const CoffeeBrandPage: React.FC = () => {
  return <LandingPageTemplate contentKey="coffeeBrand" />;
};